import { Channel, Platform } from 'shared/src/domain/line-item/line-item-channels';
import { uniqBy } from 'lodash';

export type Option = { id: number; name: string };

export function channelValues(channels: Channel[]): Option[] {
  return channels.map(c => ({ id: c.id, name: c.name }));
}

export function tacticValues(channels: Channel[]): Option[] {
  return (
    channels.map(channel => channel.tactics.map(t => ({ id: t.id, name: t.name }))).flat() || []
  );
}

export function tacticsForChannel(channels: Channel[], channelId: number): Option[] {
  return (
    channels.find(c => c.id === channelId)?.tactics.map(t => ({ id: t.id, name: t.name })) || []
  );
}

export function unitPriceTypesForTactic(channels: Channel[], tacticId: number): Option[] {
  return (
    channels
      .flatMap(c => c.tactics)
      .find(t => t.id === tacticId)
      ?.rates.map(rate => rate.unitPriceType) || []
  );
}

export function platformsForTactics(channels: Channel[], tacticId: number): Option[] {
  return channels.flatMap(c => c.tactics).find(t => t.id === tacticId)?.platforms || [];
}

export function selectedPlatforms(channels: Channel[], platformIds: number[]): Platform[] {
  const platforms = channels.flatMap(c => c.tactics.flatMap(t => t.platforms));
  return uniqBy(platforms, p => p.id).filter(p => platformIds.includes(p.id));
}
